import React from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { IGatsbyImageDataParent } from "gatsby-plugin-image/dist/src/components/hooks";

type DataProps = {
  src: IGatsbyImageDataParent<{ fluid: { originalImg: string } }>;
  pictureAll: string[];
};

const DetailItemImage = ({ src, pictureAll }: DataProps): JSX.Element => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [lbIdx, setLbIdx] = React.useState(
    pictureAll.indexOf(src.fluid.originalImg)
  );

  const image = getImage(src.gatsbyImageData);
  if (!image) {
    return <></>;
  }

  let orgSrc = undefined;
  let nextSrc = undefined;
  let onNext = undefined;
  let prevSrc = undefined;
  let onPrev = undefined;
  if (lbIdx >= 0 && lbIdx < pictureAll.length) {
    orgSrc = pictureAll[lbIdx];
    if (pictureAll.length > 1) {
      const nextIdx = (lbIdx + 1) % pictureAll.length;
      nextSrc = pictureAll[nextIdx];
      onNext = () => {
        setLbIdx(nextIdx);
      };
      const prevIdx = (lbIdx + pictureAll.length - 1) % pictureAll.length;
      prevSrc = pictureAll[prevIdx];
      onPrev = () => {
        setLbIdx(prevIdx);
      };
    }
  }

  return (
    <>
      <GatsbyImage
        image={image}
        alt=""
        style={{
          width: "100%",
          cursor: orgSrc ? "pointer" : "default",
          backgroundColor: "white",
        }}
        onClick={() => setIsOpen(!isOpen)}
      />
      {isOpen && orgSrc && (
        <Lightbox
          mainSrc={orgSrc}
          nextSrc={nextSrc}
          prevSrc={prevSrc}
          mainSrcThumbnail='data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32px 24px"><path /></svg>'
          enableZoom={false}
          wrapperClassName={"image-overlay"}
          imagePadding={50}
          onCloseRequest={() => {
            setLbIdx(pictureAll.indexOf(src.fluid.originalImg));
            setIsOpen(false);
          }}
          onMoveNextRequest={onNext}
          onMovePrevRequest={onPrev}
        />
      )}
    </>
  );
};

export default DetailItemImage;
